<template>
    <section id="all-email-logs" class="all-cases-view" v-loading="loading">
        <div class="container-small-table-rule-book">
            <div class="listings-navbar">
                <el-row>
                    <el-col :lg="24">
                        <ul class="d-flex flex-wrap justify-content-end list-items-group-15">
                            <li>
                                <el-button class="btn button-with-icon" @click="addRule()">
                                    <span class="mr-8">
                                        <img src="@/assets/images/icons/plus-icon.svg" alt="icon" class="inactive" />
                                        <img src="@/assets/images/icons/plus-icon-white.svg" alt="icon"
                                            class="active" />
                                    </span>
                                    <span>ADD RULE</span>
                                </el-button>
                            </li>
                            <li>
                                <el-button class="btn button-with-icon" @click="onRuleExport">
                                    <span class="mr-8">
                                        <img src="@/assets/images/icons/export-icon-with-bg-blue.svg" alt="icon"
                                            class="inactive" />
                                        <img src="@/assets/images/icons/export-icon-white.svg" alt="icon"
                                            class="active" />
                                    </span>
                                    <span>Export</span>
                                </el-button>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div>

            <div class="primary-content-view-new">
                <div class="listings listings__table listings__all-cases" id="all-cases-listings">
                    <el-table :data="sortedData" height="calc(100vh - 200px)" @sort-change="onChangeSort">
                        <el-table-column label="RULE NUMBER" type="index" width="130" :index="indexMethod" />

                        <el-table-column label="RULE DESCRIPTION" min-width="230" prop="case_id.accession_id">
                            <template v-slot="scope">
                                <el-tooltip effect="dark" placement="bottom" v-if="scope.row.rule_description">
                                    <template #content>
                                        <div style="max-width: 250px; white-space: normal; word-break: break-word;">
                                            {{ scope.row.rule_description }}
                                        </div>
                                    </template>
                                    <span class="text-ellipsis-2-lines">
                                        {{ scope.row.rule_description }}
                                    </span>
                                </el-tooltip>

                                <span v-else>--</span>
                            </template>
                        </el-table-column>



                        <el-table-column label="PAYERS" min-width="110" prop="case_id.accession_id">
                            <template v-slot="scope">
                                <el-tooltip effect="dark" placement="bottom" v-if="scope.row.payers">
                                    <template #content>
                                        <div style="max-width: 250px; white-space: normal; word-break: break-word;">
                                            {{ scope.row.payers }}
                                        </div>
                                    </template>
                                    <span class="text-ellipsis-2-lines">
                                        {{ scope.row.payers }}
                                    </span>
                                </el-tooltip>

                                <span v-else>--</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="Case Type" width="110" prop="case_types">
                            <template #default="scope">
                                <div v-if="scope.row.case_types && scope.row.case_types.length > 1">
                                    <el-dropdown>
                                        <span class="case-data-type">
                                            {{ scope.row.case_types[0] }}
                                            <img src="@/assets/images/case-type-arrow.svg" alt="icon" />
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu class="case-type-dropdown">
                                                <el-dropdown-item class="cases-view"
                                                    v-for="(caseType, index) in scope.row.case_types" :key="index">
                                                    {{ caseType }}
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </div>

                                <div class="case-type"
                                    v-else-if="scope.row.case_types && scope.row.case_types.length === 1">
                                    <span class="case-data-type">{{ scope.row.case_types[0] }}</span>
                                </div>

                                <div v-else>
                                    --
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Source" min-width="130" prop="case_id.accession_id">
                            <template v-slot="scope">
                                <el-tooltip effect="dark" placement="bottom" v-if="scope.row.source">
                                    <template #content>
                                        <div style="max-width: 250px; white-space: normal; word-break: break-word;">
                                            {{ scope.row.source }}
                                        </div>
                                    </template>
                                    <span class="text-ellipsis-2-lines">
                                        {{ scope.row.source }}
                                    </span>
                                </el-tooltip>

                                <span v-else>--</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="STATUS" min-width="80" prop="status">
                            <template v-slot="scope">
                                <div class="column-status cursor" v-if="scope.row.status">
                                    <el-dropdown class="status-dropdown" trigger="click"
                                        @command="(command) => changeStatus(command, scope.row._id, scope.$index)">
                                        <span class="el-dropdown-link cursor">
                                            <el-tag :type="getStatusType(scope.row.status)">
                                                {{ scope.row.status.split("_").join(" ") }}
                                            </el-tag>
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu class="status-dropdown-menu">
                                                <el-dropdown-item v-if="scope.row.status !== 'INACTIVE'"
                                                    command="INACTIVE">
                                                    INACTIVE
                                                </el-dropdown-item>
                                                <el-dropdown-item v-if="scope.row.status !== 'ACTIVE'" command="ACTIVE">
                                                    ACTIVE
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Start Date" min-width="70" prop="rule_start_date">
                            <template v-slot="scope">
                                {{ scope.row.rule_start_date ? formatDate(scope.row.rule_start_date) : "--" }}
                            </template>
                        </el-table-column>

                        <el-table-column label="End Date" min-width="70" prop="case_id.accession_id">
                            <template v-slot="scope">
                                {{ scope.row.rule_end_date ? formatDate(scope.row.rule_end_date) : "--" }}
                            </template>
                        </el-table-column>

                        <el-table-column v-if="!shouldShowUpdatedAt" prop="updated_at" label="Updated At" sortable>
                            <template #default="scope">
                                {{ scope.row.updated_at ? formatDate(scope.row.updated_at) : '--' }}
                            </template>
                        </el-table-column>


                        <el-table-column label="Actions" width="140">
                            <template #default="scope">
                                <ul class="listings__action-buttons">
                                    <li>
                                        <el-button @click="editRule(scope.row._id)">
                                            <img class="action-active"
                                                src="@/assets/images/icons/actions/edit-active.svg" alt="icon" />
                                            <img class="action-inactive"
                                                src="@/assets/images/icons/actions/edit-deactive.svg" alt="icon" />
                                        </el-button>
                                    </li>
                                    <li>
                                        <el-button @click="removeRule(scope.row._id)" class="delete-button">
                                            <img class="action-active"
                                                src="@/assets/images/icons/actions/delete-active.svg" alt="icon" />
                                            <img class="action-inactive"
                                                src="@/assets/images/icons/actions/delete-deactive.svg" alt="icon" />
                                        </el-button>
                                    </li>
                                </ul>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="listings listings__pagination">
                <el-pagination v-model:currentPage="page" v-model:page-size="pageSize" :page-sizes="[25, 50, 75, 100]"
                    layout=" prev, pager, next, jumper, sizes ,total" :total="getAllRules.total"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
    successNotification,
    errorNotification,
} from "@/helpers/notifications";

export default {
    components: {},
    computed: {
        ...mapGetters("rulebook", ["getAllRules", "getRuleCreationStatus", "getRuleRemoveStatus", "getRuleExportStatus", "getUpdateStatus"]),
        getStatusType() {
            return (statusVal) => {
                const status = statusVal.trim();
                if (status == "ACTIVE") {
                    return "success";
                } else if (status == "INACTIVE") {
                    return "danger";
                }
            };
        },
        sortedData() {
            const data = this.getAllRules && Array.isArray(this.getAllRules.data)
                ? this.getAllRules.data
                : [];

            const sorted = [...data];

            if (!this.shouldShowUpdatedAt) {
                sorted.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
            }

            return sorted;
        },
    },
    mounted() {
        this.setQueryParamsData();
        this.fetchRules();
    },
    data() {
        return {
            page: 1,
            pageSize: 25,
            orderBy: "created_at",
            orderType: "desc",
            loading: false,
            logsTable: {},
            data: [],
            shouldShowUpdatedAt: true
        };
    },

    methods: {
        indexMethod(index) {
            return index + 1;
        },
        async removeRule(ruleId) {
            try {
                this.loading = true;
                await this.$store.dispatch("rulebook/removeRule", ruleId);
                this.loading = false;
                if (this.getRuleRemoveStatus) {
                    successNotification("Rule deleted successfully");
                    await this.fetchRules();
                } else {
                    errorNotification("Error at deleting Rule");
                }
            } catch (err) {
                this.loading = false;
                console.error(err);
            }
        },
        async onRuleExport() {
            try {
                let params = {}
                const routeCategoryMap = {
                    AllCodingRules: "Coding Rule Book",
                    AllClaim: "Claim Processing",
                    AllARRules: "AR Rule Book",
                    PaymentRules: "Payment Posting Rule Book",
                    PatientRules: "Patient Statement Rule Book",
                };

                const category = routeCategoryMap[this.$route.name];
                if (category) {
                    params.category = category;
                }

                await this.$store.dispatch("rulebook/exportRules", params)
                if (this.getRuleExportStatus) {
                    successNotification("Rule book details downloaded successfully")
                } else {
                    errorNotification("Error in downloading rule book")
                }
            } catch (err) {
                console.log(err)
            }
        },
        editRule(rule) {
            this.$router.push({
                name: "UpdatedRules",
                params: { rule_id: rule }
            })
        },
        addRule() {
            this.$router.push({
                name: "AddRules"
            })
        },
        getAutoCompleteCases() {
            setTimeout(() => {
                this.page = 1;
                this.fetchRules();
            }, 600);
        },
        onChangeSort({ order, prop }) {
            if (order && prop) {
                this.orderBy = prop;
                this.orderType = order == "ascending" ? "asc" : "desc";
            } else {
                this.orderBy = "created_at";
                this.orderType = "DESC";
            }
            this.fetchRules();
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.page = 1;

            this.fetchRules();
        },
        handleCurrentChange(page) {
            this.page = page;

            this.fetchRules();
        },
        prepareParams() {
            const params = {
                page: this.page,
                limit: this.pageSize,
            };
            if (this.search_string) {
                params.search_string = this.search_string;
            }
            if (this.orderBy && this.orderType) {
                params.order_by = this.orderBy.toLowerCase();
                params.order_type = this.orderType;
            }
            const routeCategoryMap = {
                AllCodingRules: "Coding Rule Book",
                AllClaim: "Claim Processing",
                AllARRules: "AR Rule Book",
                PaymentRules: "Payment Posting Rule Book",
                PatientRules: "Patient Statement Rule Book",
            };

            const category = routeCategoryMap[this.$route.name];
            if (category) {
                params.category = category;
            }
            return params;
        },

        setQueryParamsData() {
            this.page = this.$route.query.selectedPage
                ? parseInt(this.$route.query.selectedPage)
                : 1;
            this.pageSize = this.$route.query.selectedPageSize
                ? parseInt(this.$route.query.selectedPageSize)
                : 25;
            if (this.$route.query.selectedString) {
                this.search_string = this.$route.query.selectedString;
            }
            if (this.$route.query.selectedOrderBy) {
                this.orderBy = this.$route.query.selectedOrderBy;
            }
            if (this.$route.query.selectedOrderType) {
                this.orderType = this.$route.query.selectedOrderType;
            }
        },
        updateQueryParams(params) {
            let selectedParams = {
                selectedPage: params.page,
                selectedString: params.search_string,
                selectedPageSize: params.limit,
                selectedOrderBy: params.order_by,
                selectedOrderType: params.order_type,
            };
            if (this.$route.query !== selectedParams) {
                this.$router.replace({ query: selectedParams });
            }
        },
        async fetchRules() {
            try {
                this.loading = true;
                let params = this.prepareParams();
                await this.$store.dispatch("rulebook/fetchAllRules", params);
                this.updateQueryParams(params);
                this.logsTable = JSON.parse(JSON.stringify(this.getAllRules));
                this.loading = false;
            } catch (err) {
                this.loading = false;
                console.log(err);
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()}`;
        },
        async updateStatus(params, index) {
            try {
                this.loading = true;
                await this.$store.dispatch("rulebook/updateStatus", params, {
                    root: true,
                });
                this.loading = false;
                if (this.getUpdateStatus) {
                    successNotification("Rule Status Updated successfully")
                } else {
                    errorNotification("Error in updating Rule Status")
                }
                this.fetchRules();

            } catch (err) {
                console.log(err);
                this.loading = false;
            }
        },
        async changeStatus(command, ruleData, index) {
            try {
                if (command == ruleData.status) {
                    return;
                }
                let params = {
                    status: command,
                    id: ruleData,
                };
                await this.updateStatus(params, index);

            } catch (err) {
                console.log(err);
            }
        },
    },
    watch: {
        '$route.name'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchRules();
            }
        }
    }
};

</script>

<style lang="scss" scoped>
#all-email-logs {
    .listings__table .el-table table tbody tr td.el-table__cell {
        padding: 2.7px;
    }
}

.container-small-table-rule-book {
    max-width: 90%;
    margin: 0 auto;
    padding: 15px 0;
}

.case-type-dropdown {
    padding: 2px 0 !important;

    .el-dropdown-menu__item {
        width: 140px !important;
        font-size: 12px;
    }
}

.cases-view {
    height: 30px;
    padding: 0 5px !important;
    margin: 5px !important;
    color: #4477ae !important;
    font-weight: 500 !important;
    background: #f2f2f2 !important;
    border-radius: 4px !important;
    cursor: default !important;

    .el-dropdown__popper .el-dropdown-menu {
        padding: 0 !important;
    }
}

.case-data-type {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
}

.text-ellipsis-2-lines {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.listings__action-buttons {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 5px;

    li {
        .el-button {
            padding: 5px;
            border: none;
            background: transparent;

            &:hover {
                .action-active {
                    display: block;
                }
                .action-inactive {
                    display: none;
                }
            }

            .action-active {
                display: none;
            }
            .action-inactive {
                display: block;
            }
        }
    }
}
</style>
